import { Box, Button } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0.75rem 0;
`;

export const TCStyledButton = styled(Button)<{
  $primary?: boolean;
}>`
  && {
    background-color: ${(props) =>
      props.$primary ? COLORS.BLUE : COLORS.GRAY_1};
    color: ${(props) => (props.$primary ? 'white' : COLORS.GRAY_3)};
    font-weight: 600;
    font-size: 0.6rem;
    padding: 3px 8px;
    border-radius: 3px;
    min-width: unset;

    &:disabled {
      opacity: 0.7;
      filter: grayscale(0.2);
      color: white;
    }

    &:hover {
      background-color: ${(props) =>
        props.$primary ? COLORS.LIGHT_BLUE : COLORS.GRAY_2};
    }
  }
`;

export const UsersContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
`;

export const UserCircle = styled(Box)<{
  $backgroundColor?: string;
}>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.$backgroundColor ? props.$backgroundColor : '#E0E0E0'};
  border: 2px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
`;
